import { render } from "./EditImmigration.vue?vue&type=template&id=68829a67&scoped=true"
import script from "./EditImmigration.vue?vue&type=script&lang=js"
export * from "./EditImmigration.vue?vue&type=script&lang=js"

import "./EditImmigration.vue?vue&type=style&index=0&id=68829a67&scoped=true&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68829a67"]])

export default __exports__